// DashboardActivityListExpanded.tsx - Simple wrapper that opens DashboardActivityList in popup
import React from 'react';
import PopupComponent from '../../components/PopupComponent';
import DashboardActivityList from './DashboardActivityList';
import logger from '../../utils/logger';

// Console logging for debugging
logger.log('🔍 DashboardActivityListExpanded wrapper component loaded');

interface DashboardActivityListExpandedProps {
  isOpen: boolean;
  onClose: () => void;
  fromDate: string;
  toDate: string;
  organization: boolean;
  userId: string;
  selectedTeamId: string;
  title?: string;
}

const DashboardActivityListExpanded: React.FC<DashboardActivityListExpandedProps> = ({
  isOpen,
  onClose,
  fromDate,
  toDate,
  organization,
  userId,
  selectedTeamId,
  title = "Recent Activities"
}) => {
  logger.log('🔍 Rendering expanded activity list popup:', { isOpen, title });

  return (
    <PopupComponent
      isOpen={isOpen}
      onClose={onClose}
      title={`${title} - Detailed View`}
      size="lg"
      footer={
        <div style={{ 
          display: "flex", 
          justifyContent: "flex-end", 
          alignItems: "center",
          padding: "0 8px",
          width: "100%"
        }}>
          <button 
            onClick={onClose}
            style={{
              padding: "8px 20px",
              backgroundColor: "#6b7280",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "14px",
              cursor: "pointer",
              fontWeight: "500"
            }}
          >
            Close
          </button>
        </div>
      }
    >
      <div style={{ 
        height: "75vh", 
        display: "flex", 
        flexDirection: "column",
        padding: "16px 0"
      }}>
        {/* Simple container for the existing DashboardActivityList */}
        <div style={{ 
          flex: 1, 
          overflow: "hidden",
          border: "1px solid #e5e7eb",
          borderRadius: "8px"
        }}>
          {/* Reuse existing DashboardActivityList component exactly as-is */}
          <DashboardActivityList
            fromDate={fromDate}
            toDate={toDate}
            organization={organization}
            userId={userId}
            selectedTeamId={selectedTeamId}
            title="Activities"
          />
        </div>
      </div>
    </PopupComponent>
  );
};

export default DashboardActivityListExpanded;